import React, { useState } from "react";
import AddressForm from "../address/AddressForm";

function CheckoutModal({
  open,
  onClose,
  addresses = [],
  defaultAddressId = null,
  onCheckout,
  addAddressFn,
  isLoading = false,
}) {
  const [selectedAddressId, setSelectedAddressId] = useState(defaultAddressId);
  const [showAddForm, setShowAddForm] = useState(false);

  if (!open) return null;

  const handleSelect = (id) => {
    setSelectedAddressId(id);
  };

  const handleAddAddress = (formData) => {
    addAddressFn(formData);
    setShowAddForm(false);
  };

  return (
    <div className="w-full fixed inset-0 z-50 flex items-center justify-center bg-black/50 bg-opacity-40">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl p-6 relative animate-fade-in">
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-2xl font-bold"
          onClick={() => onClose(false)}
        >
          &times;
        </button>
        <h2 className="text-xl font-bold mb-4">Select Delivery Address</h2>
        {addresses.length > 0 && !showAddForm ? (
          <>
            <div className="space-y-3 max-h-60 overflow-y-auto mb-4">
              {addresses.map((addr) => (
                <label
                  key={addr.id || addr._id}
                  className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                    selectedAddressId === (addr.id || addr._id)
                      ? "border-red-500 bg-red-50"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <input
                    type="radio"
                    name="address"
                    value={addr.id || addr._id}
                    checked={selectedAddressId === (addr.id || addr._id)}
                    onChange={() => handleSelect(addr.id || addr._id)}
                    className="mt-1 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300"
                  />
                  <div className="flex-1">
                    <div className="font-semibold text-gray-900">
                      {addr.title}
                    </div>
                    <div className="text-gray-700 text-sm">
                      {addr.street}, {addr.city}, {addr.state}, {addr.zipCode}
                    </div>
                    {addr.isDefault && (
                      <span className="inline-block mt-1 px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded">
                        Default
                      </span>
                    )}
                  </div>
                </label>
              ))}
            </div>
            <div className="flex justify-between items-center mt-4">
              <button
                className="text-sm text-blue-600 hover:underline"
                onClick={() => setShowAddForm(true)}
              >
                + Add New Address
              </button>
              <button
                className="bg-[#DA0E1A] text-white px-6 py-2 rounded-lg font-semibold hover:bg-red-700 transition-colors disabled:opacity-50"
                disabled={!selectedAddressId || isLoading}
                onClick={() => onCheckout(selectedAddressId)}
              >
                {isLoading ? "Processing..." : "Checkout"}
              </button>
            </div>
          </>
        ) : (
          <div>
            <AddressForm
              onSubmit={handleAddAddress}
              onCancel={() => setShowAddForm(false)}
              isLoading={isLoading}
              type="order"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default CheckoutModal;
